import React from 'react';
import ComingSoon from '@/components/shared/ComingSoonSection';
import './SettingsPage.scss';

const SettingsPage = () => {
  return (
    <div className="SettingsPage">
      <ComingSoon title="SettingsPage" />
    </div>
  );
};

export default SettingsPage;
